var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"job-container"},[_c('b-overlay',{attrs:{"show":_vm.loading,"rounded":"lg"}}),(!_vm.loading)?_c('JobComp',{attrs:{"job":_vm.job}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }